import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { getIsShadowMailbox } from 'mini-user-config/lib/getIsShadowMailbox';
import { getPackageBaseUrl } from 'owa-config';
import { urlResolve } from 'mini-common-utils/lib/utils/urlResolve';
import { getConsumerImageUrl } from './getConsumerImageUrl';
import { getAccountScopeUserConfiguration } from 'mini-common-utils/lib/utils/getAccountScopeUserConfiguration';

const GOOGLE_LOGO_PATH_BACKGROUND_FILLED = 'resources/images/googleLogoBgFilled.svg';

/**
 * Returns the avatar url for the account persona
 */
export const getAccountAvatarUrl = () => {
    const { HexCID } = getAccountScopeUserConfiguration();

    if (getIsShadowMailbox()) {
        return urlResolve(getPackageBaseUrl(), GOOGLE_LOGO_PATH_BACKGROUND_FILLED);
    }
    if (isConsumer()) {
        return getConsumerImageUrl(HexCID);
    }
    return undefined;
};
